import { defineBrowserModule } from "@amtana/browser";
import type { BrowserModule } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";
import { OrganizationSwitcher } from "@amtana/organization-client";

import { ORGANIZATION_CATALOGS } from "./model/organization-copy.ts";
import { ORGANIZATION_ERROR_COPY } from "./model/organization-error-copy.ts";

// The members directory under Settings (S3.02): name, email, role and
// status; a role picker and remove for an admin (S4.06), leave for anyone;
// inviting, resending, copying a link and revoking (S3.04, S3.06). Where a
// mailed invite link lands (S3.05): the "auth" layout, since it must render
// for a signed-out person too. The organization settings screen (S1.06:
// rename, logo, delete with a grace period) and the shell's switcher (S1.05)
// join it here.
export const organizationBrowserModule: BrowserModule = defineBrowserModule("organization")
  .withErrorCopy(ORGANIZATION_ERROR_COPY)
  .withScreens({
    members: {
      path: "/settings/members",
      title: phrase(ORGANIZATION_CATALOGS, "screenTitleMembers"),
      layout: "app",
      load: () => import("./ui/sections/members-screen.tsx"),
    },
    settings: {
      path: "/settings/organization",
      title: phrase(ORGANIZATION_CATALOGS, "screenTitleSettings"),
      layout: "app",
      load: () => import("./ui/sections/organization-settings-screen.tsx"),
    },
    acceptInvite: {
      path: "/invite/accept",
      title: phrase(ORGANIZATION_CATALOGS, "screenTitleAcceptInvite"),
      layout: "auth",
      load: () => import("./ui/sections/accept-invite-screen.tsx"),
    },
  })
  .withLends([{ token: OrganizationSwitcher, load: () => import("./ui/blocks/organization-switcher.tsx") }])
  .withNavigation([
    {
      id: "members",
      group: "settings-workspace",
      label: phrase(ORGANIZATION_CATALOGS, "navMembers"),
      href: "/settings/members",
      icon: "users",
      order: 854,
    },
    {
      id: "organization",
      group: "settings-workspace",
      label: phrase(ORGANIZATION_CATALOGS, "navOrganization"),
      href: "/settings/organization",
      icon: "building",
      order: 850,
    },
  ]);
